export enum NextMethodsEnum {
    beautifyWorkshiftEvent = 'beautifyWorkshiftEvent',
    cancelAbsenceDay = 'cancelAbsenceDay',
    cancelTaskList = 'cancelTaskList',
    cancelWorkshiftList = 'cancelWorkshiftList',
    changeDTypeRepositoryName = 'changeDTypeRepositoryName',
    changeForgottenPassword = 'changeForgottenPassword',
    changePassword = 'changePassword',
    changePremisesLinkStatus = 'changePremisesLinkStatus',
    changeServiceStatus = 'changeServiceStatus',
    changeServiceUserAssignmentTrained = 'changeServiceUserAssignmentTrained',
    changeServiceWorkplaceUserAssignmentJob = 'changeServiceWorkplaceUserAssignmentJob',
    changeUserStatus = 'changeUserStatus',
    checkDataQualityTaskList = 'checkDataQualityTaskList',
    checkDTypeGoingLive = 'checkDTypeGoingLive',
    checkTokenGenuineness = 'checkTokenGenuineness',
    cleanPremisesGenericNet4Concepts = 'cleanPremisesGenericNet4Concepts',
    cloneNextServicio = 'cloneNextServicio',
    copyDailyTaskPlannedActivities = 'copyDailyTaskPlannedActivities',
    copyDailyTaskPlanningToFuture = 'copyDailyTaskPlanningToFuture',
    createDocumentWeeklyWork = 'createDocumentWeeklyWork',
    deleteCalendar = 'deleteCalendar',
    deleteDType = 'nextDeleteDType',
    deleteTaskType = 'deleteNextTaskType',
    deleteDTypeData = 'deleteDTypeData',
    deleteNextCliente = 'deleteNextCliente',
    deleteNextDoc = 'deleteNextDoc',
    deleteNextMarca = 'deleteNextMarca',
    deleteNextProyecto = 'deleteNextProyecto',
    deleteNextServicio = 'deleteNextServicio',
    deleteNextServicioJob = 'deleteNextServicioJob',
    deleteNextServicioMissionInfo = 'deleteNextServicioMissionInfo',
    deleteNextServicioUserArea = 'deleteNextServicioUserArea',
    deleteForm = 'deleteForm',
    deletePlanningArea = 'deletePlanningArea',
    deletePremisesCenterBaseList = 'deletePremisesCenterBaseList',
    deletePremisesCenterActivityCategoryList = 'deletePremisesCenterActivityCategoryList',
    deletePremisesCenterContact = 'deletePremisesCenterContact',
    deletePremisesCenterShiftList = "deletePremisesCenterShiftList",
    deletePremisesGenericActivityTypeObjective = 'deletePremisesGenericActivityTypeObjective',
    deletePremisesGenericContact = 'deletePremisesGenericContact',
    deletePremisesGenericShiftList = 'deletePremisesGenericShiftList',
    deletePremisesHotelClosingConcept = 'deletePremisesHotelClosingConcept',
    deletePremisesHotelContact = 'deletePremisesHotelContact',
    deletePremisesHotelOccupancyEvents = 'deletePremisesHotelOccupancyEvents',
    deletePremisesHotelRoomCatalogList = 'deletePremisesHotelRoomCatalogList',
    deletePremisesHotelShiftList = 'deletePremisesHotelShiftList',
    deletePremisesHotelTipList = 'deletePremisesHotelTipList',
    deleteTask = 'deleteTask',
    deleteTaskList = 'deleteTaskList',
    deleteWeldonActivity = 'deleteWeldonActivity',
    deleteWorkshiftList = 'deleteWorkshiftList',
    dismissServiceUserAssignment = 'dismissServiceUserAssignment',
    downloadFile = 'formdata?labor=downloadFile',
    downloadNextMasterXSSF = 'downloadNextMasterXSSF',
    downloadNodeUserAppVersionXSSF = 'downloadNodeUserAppVersionXSSF',
    downloadSearchAbsencesXSSF = 'downloadSearchAbsencesXSSF',
    downloadSearchTaskXSSF = 'downloadSearchTaskXSSF',
    downloadSearchWeldonActivityListXSSF = 'downloadSearchWeldonActivityListXSSF',
    downloadServiceGoalsModelXSSF = 'downloadServiceGoalsModelXSSF',
    downloadServiceFormsXSSF = 'downloadServiceFormsXSSF',
    downloadServiceResourcesModelXSSF = 'downloadServiceResourcesModelXSSF',
    downloadServiceTasksModelXSSF = 'downloadServiceTasksModelXSSF',
    downloadNextMasterFormStructureXSSF = 'downloadNextMasterFormStructureXSSF',
    downloadPremisesGenericWorkRealizedConceptXSSF = 'downloadPremisesGenericWorkRealizedConceptXSSF',
    ejectConnectedDevice = 'ejectConnectedDevice',
    executeTaskCustomAction = 'executeTaskCustomAction',
    exportMasterFormHierarchyItem = 'exportMasterFormHierarchyItem',
    exportNextServicio = 'exportNextServicio',
    finishPeriodicEvent = 'finishPeriodicEvent',
    finishTheParty = 'finishTheParty',
    flushAbsenceReview = 'flushAbsenceReview',
    flushBeautifyTask = 'flushBeautifyTask',
    flushCompany = 'flushCompany',
    flushCompanyUser = 'flushCompanyUser',
    flushDailyPayroll = 'flushDailyPayroll',
    flushDailyTask = 'flushDailyTask',
    flushDailyTaskActivityData = 'flushDailyTaskActivityData',
    flushDailyTaskPlannedActivityData = 'flushDailyTaskPlannedActivityData',
    flushDailyTaskData = 'flushDailyTaskData',
    flushDailyTaskList = 'flushDailyTaskList',
    flushDocumentStatus = 'flushDocumentStatus',
    flushDocumentStatusPremisesHotelWork = 'flushDocumentStatusPremisesHotelWork',
    flushDTypeExcelUpload = 'flushDTypeExcelUpload',
    flushDTypeRepository = 'flushDTypeRepository',
    flushDTypeDataItem = 'flushDTypeDataItem',
    flushMasterOrder = 'flushMasterOrder',
    flushDTypeRepositoryToGoLiveRequest = 'flushDTypeRepositoryToGoLiveRequest',
    flushDTypeRepositoryToGoLiveSchedule = 'flushDTypeRepositoryToGoLiveSchedule',
    flushForm = 'flushForm',
    flushLocationChangeResult = 'flushLocationChangeResult',
    flushMasterCategoryTree = 'flushMasterCategoryTree',
    flushMasterFormHierarchyItem = 'flushMasterFormHierarchyItem',
    flushMonthlyPayroll = 'flushMonthlyPayroll',
    flushMultiTaskEdit = 'flushMultiTaskEdit',
    flushCalendar = 'flushCalendar',
    flushNextCliente = 'flushNextCliente',
    flushNextDoc = 'flushNextDoc',
    flushNextMarca = 'flushNextMarca',
    flushNextPresenceConfiguration = 'flushNextPresenceConfiguration',
    flushNextProyecto = 'flushNextProyecto',
    flushNextServicio = 'flushNextServicio',
    flushNextServicioJob = 'flushNextServicioJob',
    flushNextServicioMissionInfo = 'flushNextServicioMissionInfo',
    flushNextServicioUserArea = 'flushNextServicioUserArea',
    flushNextTaskGoal = 'flushNextTaskGoal',
    flushNextTaskType = 'flushNextTaskType',
    flushPeriodicEvent = 'flushPeriodicEvent',
    flushPlanningArea = 'flushPlanningArea',
    flushPremisesActivityTypeOrder = 'flushPremisesActivityTypeOrder',
    flushPremisesCenterActivity = 'flushPremisesCenterActivity',
    flushPremisesCenterBase = 'flushPremisesCenterBase',
    flushPremisesCenterActivityCategory = 'flushPremisesCenterActivityCategory',
    flushPremisesCenterContact = 'flushPremisesCenterContact',
    flushPremisesCenterGeneral = 'flushPremisesCenterGeneral',
    flushPremisesCenterShift = "flushPremisesCenterShift",
    flushPremisesCenterWorkClientRemarks = 'flushPremisesCenterWorkClientRemarks',
    flushPremisesGenericActivityType = 'flushPremisesGenericActivityType',
    flushPremisesGenericActivityTypeObjective = 'flushPremisesGenericActivityTypeObjective',
    flushPremisesGenericContact = 'flushPremisesGenericContact',
    flushPremisesGenericGroups = 'flushPremisesGenericGroups',
    flushPremisesGenericShift = "flushPremisesGenericShift",
    flushPremisesGenericWorkClientRemarks = 'flushPremisesGenericWorkClientRemarks',
    flushPremisesGenericWorkRealizedConcept = 'flushPremisesGenericWorkRealizedConcept',
    flushPremisesHotelActivity = 'flushPremisesHotelActivity',
    flushPremisesHotelActivityGeneral = 'flushPremisesHotelActivityGeneral',
    flushPremisesHotelClosingConcept = 'flushPremisesHotelClosingConcept',
    flushPremisesHotelContact = 'flushPremisesHotelContact',
    flushPremisesHotelDailyOccupancy = 'flushPremisesHotelDailyOccupancy',
    flushPremisesHotelGeneral = 'flushPremisesHotelGeneral',
    flushPremisesHotelOccupancyYearly = 'flushPremisesHotelOccupancyYearly',
    flushPremisesHotelOccupancyEvents = 'flushPremisesHotelOccupancyEvents',
    flushPremisesHotelRatio = 'flushPremisesHotelRatio',
    flushPremisesHotelRoomCatalog = 'flushPremisesHotelRoomCatalog',
    flushPremisesHotelShift = 'flushPremisesHotelShift',
    flushPremisesHotelTip = 'flushPremisesHotelTip',
    flushPremisesHotelWorkClientRemarks = 'flushPremisesHotelWorkClientRemarks',
    flushPremisesHotelWorkCustomClosingConceptData = 'flushPremisesHotelWorkCustomClosingConceptData',
    flushServiceUserAssignment = 'flushServiceUserAssignment',
    flushServiceUserAssignmentList = 'flushServiceUserAssignmentList',
    flushTask = 'flushTask',
    flushTaskMultipleUsers = 'flushTaskMultipleUsers',
    flushServiceTaskTypeAssignmentList = 'flushServiceTaskTypeAssignmentList',
    flushUserNodePrivileges = 'flushUserNodePrivileges',
    flushUser2NextCliente = 'flushUser2NextCliente',
    flushUser2NextMarca = 'flushUser2NextMarca',
    flushUser2NextProyecto = 'flushUser2NextProyecto',
    flushUser2NextServicio = 'flushUser2NextServicio',
    flushWeldonActivity = 'flushWeldonActivity',
    flushWorkshift = 'flushWorkshift',
    forceTaskStartEnd = 'forceTaskStartEnd',
    forceWorkshiftStartEnd = 'forceWorkshiftStartEnd',
    forwardDTypeToLive = 'forwardDTypeToLive',
    generateDocumentPremisesHotelWork = 'generateDocumentPremisesHotelWork',
    generatePremisesCenterWork = 'generatePremisesCenterWork',
    generatePremisesCenterMagicCode = 'generatePremisesCenterMagicCode',
    generatePremisesGenericWork = 'generatePremisesGenericWork',
    generatePremisesHotelMagicCode = 'generatePremisesHotelMagicCode',
    generatePremisesHotelWork = 'generatePremisesHotelWork',
    importNextServicio = 'importNextServicio',
    importMasterFormHierarchyItem = 'importMasterFormHierarchyItem',
    joinTheParty = 'joinTheParty',
    nextValue = 'nextValue',
    notifySystemChangesForUsers = 'notifySystemChangesForUsers',
    regenerateDailyTaskData = 'regenerateDailyTaskData',
    regenerateDailyTaskDataPeriod = 'regenerateDailyTaskDataPeriod',
    regeneratePassword = 'regeneratePassword',
    removeDropzoneFile = 'removeDropzoneFile',
    requestMobileLog = 'requestMobileLog',
    requestServiceSynchronization = 'requestServiceSynchronization',
    resetTaskList = 'resetTaskList',
    resetWorkshiftList = 'resetWorkshiftList',
    resetDTypeRepository = 'resetDTypeRepository',
    retrieveAbsenceForms = 'retrieveAbsenceForms',
    retrieveAddressByGoogle = 'retrieveAddressByGoogle',
    retrieveAvailabilityControlSearchOptions = 'retrieveAvailabilityControlSearchOptions',
    retrieveBusTargetRatio = 'retrieveBusTargetRatio',
    retrieveCompanyUserList = 'retrieveCompanyUserList',
    retrieveCompanyUserMissionUserList = 'retrieveCompanyUserMissionUserList',
    retrieveCompanyUserMissionUserListDN = 'retrieveCompanyUserMissionUserListDN',
    retrieveCompatibleTaskTypes = 'retrieveCompatibleTaskTypes',
    retrieveConnectedDevice = 'retrieveConnectedDevice',
    retrieveDataByUri = 'retrieveDataByUri',
    retrieveDatatype = 'retrieveDatatype',
    retrieveDailyPayrollOptions = 'retrieveDailyPayrollOptions',
    retrieveDailyPayrolls = 'retrieveDailyPayrolls',
    retrieveDailyPayrollSummary = 'retrieveDailyPayrollSummary',
    retrieveDailyTaskData = 'retrieveDailyTaskData',
    retrieveDocumentStatusPremisesHotelWork = 'retrieveDocumentStatusPremisesHotelWork',
    retrieveDTypeBuilderCollection = 'retrieveDTypeBuilderCollection',
    retrieveDTypeDataCollection = 'retrieveDTypeDataCollection',
    retrieveDTypeDataItem = 'retrieveDTypeDataItem',
    retrieveDTypeGoLiveRequest = 'retrieveDTypeGoLiveInfo',
    retrieveEnumerationType = 'retrieveEnumerationType',
    retrieveCalendarDateList = 'retrieveCalendarDateList',
    retrieveCalendarWithDN = 'retrieveCalendarWithDN',
    retrieveNextCliente = 'retrieveNextCliente',
    retrieveNextClienteList = 'retrieveNextClienteList',
    retrieveNextDocList = 'retrieveNextDocList',
    retrieveNextOu = 'retrieveNextOu',
    retrieveNextPermissions = 'retrieveNextPermissions',
    retrieveDTypeByUri = 'retrieveDTypeByUri',
    retrieveDTypeCollectionDN = 'retrieveDTypeCollectionDN',
    retrieveDTypeRepositoryByUri = 'retrieveDTypeRepositoryByUri',
    retrieveLocationChangeRequest = 'retrieveLocationChangeRequest',
    retrieveMasterCategoryTree = 'retrieveMasterCategoryTree',
    retrieveMasterCollectionDN = 'retrieveMasterCollectionDN',
    retrieveMasterDataAsSelectOption = 'retrieveMasterDataAsSelectOption',
    retrieveMasterFormHierarchy = 'retrieveMasterFormHierarchy',
    retrieveModifiedMasterInstance = 'retrieveModifiedMasterInstance',
    retrieveMonthlyPayrollOptions = 'retrieveMonthlyPayrollOptions',
    retrieveMonthlyPayrolls = 'retrieveMonthlyPayrolls',
    retrieveMonthlyPayrollSummary = 'retrieveMonthlyPayrollSummary',
    retrieveMonthlyTotalByNet4Concept = 'retrieveMonthlyTotalByNet4Concept',
    retrieveMonthlyTotalByNet4Concept4Client = 'retrieveMonthlyTotalByNet4Concept4Client',
    retrieveMultiTaskEdit = 'retrieveMultiTaskEdit',
    retrieveNewFormInstance = 'retrieveNewFormInstance',
    retrieveNewMasterInstance = 'retrieveNewMasterInstance',
    retrieveNewNextTaskTypeInstance = 'retrieveNewNextTaskTypeInstance',
    retrieveWorkshiftResources = 'retrieveWorkshiftResources',
    retrieveNextMarca = 'retrieveNextMarca',
    retrieveNextMarcaList = 'retrieveNextMarcaList',
    retrieveNextPresenceConfiguration = 'retrieveNextPresenceConfiguration',
    retrieveNextProyecto = 'retrieveNextProyecto',
    retrieveNextProyectoList = 'retrieveNextProyectoList',
    retrieveNextServicio = 'retrieveNextServicio',
    retrieveNextServicioJobList = 'retrieveNextServicioJobList',
    retrieveNextServicioList = 'retrieveNextServicioList',
    retrieveNextServicioUserAreaList = 'retrieveNextServicioUserAreaList',
    retrieveNextTaskCustomGoalAutoAssignment = 'retrieveNextTaskCustomGoalAutoAssignment',
    retrieveNextTaskTypeById = 'retrieveNextTaskTypeById',
    retrieveNextTaskTypeCollectionDN = 'retrieveNextTaskTypeCollectionDN',
    retrieveNodeHierarchyItem = 'retrieveNodeHierarchyItem',
    retrievePlanningAreaList = 'retrievePlanningAreaList',
    retrievePremisesDailyWork = 'retrievePremisesDailyWork',
    retrievePremisesDailyWorkSearchOptions = 'retrievePremisesDailyWorkSearchOptions',
    retrievePremisesCenterBaseList = 'retrievePremisesCenterBaseList',
    retrievePremisesCenterActivityCategoryList = 'retrievePremisesCenterActivityCategoryList',
    retrievePremisesCenterActivityTypeList = 'retrievePremisesCenterActivityTypeList',
    retrievePremisesCenterContactList = 'retrievePremisesCenterContactList',
    retrievePremisesCenterGeneral = 'retrievePremisesCenterGeneral',
    retrievePremisesCenterNet4Concepts = 'retrievePremisesCenterNet4Concepts',
    retrievePremisesCenterShiftList = "retrievePremisesCenterShiftList",
    retrievePremisesCenterShiftScheduleList = 'retrievePremisesCenterShiftScheduleList',
    retrievePremisesCenterWork = 'retrievePremisesCenterWork',
    retrievePremisesGenericActivityTypeObjectiveList = 'retrievePremisesGenericActivityTypeObjectiveList',
    retrievePremisesGenericActivityTypeList = 'retrievePremisesGenericActivityTypeList',
    retrievePremisesGenericContactList = 'retrievePremisesGenericContactList',
    retrievePremisesGenericGroups = 'retrievePremisesGenericGroups',
    retrievePremisesGenericNet4Concepts = 'retrievePremisesGenericNet4Concepts',
    retrievePremisesGenericShiftList = 'retrievePremisesGenericShiftList',
    retrievePremisesGenericShiftScheduleList = 'retrievePremisesGenericShiftScheduleList',
    retrievePremisesGenericWork = 'retrievePremisesGenericWork',
    retrievePremisesHotelActivityGeneral = 'retrievePremisesHotelActivityGeneral',
    retrievePremisesHotelActivityList = 'retrievePremisesHotelActivityList',
    retrievePremisesHotelClosingConceptList = 'retrievePremisesHotelClosingConceptList',
    retrievePremisesHotelContactList = 'retrievePremisesHotelContactList',
    retrievePremisesHotelGeneral = 'retrievePremisesHotelGeneral',
    retrievePremisesMonthlyWork = 'retrievePremisesMonthlyWork',
    retrievePremisesMonthlyWork4Client = 'retrievePremisesMonthlyWork4Client',
    retrievePremisesHotelNet4Concepts = 'retrievePremisesHotelNet4Concepts',
    retrievePremisesHotelOccupancyYearly = 'retrievePremisesHotelOccupancyYearly',
    retrievePremisesHotelOccupancyEvents = 'retrievePremisesHotelOccupancyEvents',
    retrievePremisesHotelRatio = 'retrievePremisesHotelRatio',
    retrievePremisesHotelRoomCatalogList = 'retrievePremisesHotelRoomCatalogList',
    retrievePremisesHotelShiftList = 'retrievePremisesHotelShiftList',
    retrievePremisesHotelShiftScheduleList = 'retrievePremisesHotelShiftScheduleList',
    retrievePremisesHotelTipList = 'retrievePremisesHotelTipList',
    retrievePremisesHotelWork = 'retrievePremisesHotelWork',
    retrievePremisesLink = 'retrievePremisesLink',
    retrievePremisesLinkList = 'retrievePremisesLinkList',
    retrievePremisesWeeklyWork = 'retrievePremisesWeeklyWork',
    retrievePremisesWorkplaceBillingAutomationConfig = 'retrievePremisesWorkplaceBillingAutomationConfig',
    retrievePushNotificationBySender = 'retrievePushNotificationBySender',
    retrieveServiceTableInfo = 'retrieveServiceTableInfo',
    retrieveServiceTaskTypeAssignmentList = 'retrieveServiceTaskTypeAssignmentList',
    retrieveServiceUserAssignmentList = 'retrieveServiceUserAssignmentList',
    retrieveServiceWorkplaceUserAssignment = 'retrieveServiceWorkplaceUserAssignment',
    retrieveSystemChangesForUsers = 'retrieveSystemChangesForUsers',
    retrieveTaskSearchOptions = 'retrieveTaskSearchOptions',
    retrieveMissionUserQR = 'retrieveMissionUserQR',
    retrieveNextServicioMissionInfo = 'retrieveNextServicioMissionInfo',
    retrieveNextTaskGoal = 'retrieveNextTaskGoal',
    retrievePasswordDailyLog = 'retrievePasswordDailyLog',
    retrieveServiceFormsOptions = 'retrieveServiceFormsOptions',
    retrieveTaskAssignments = 'retrieveTaskAssignments',
    retrieveTaskById = 'retrieveTaskById',
    retrieveUserCalendar = 'retrieveUserCalendar',
    retrieveUserDailyLog = 'retrieveUserDailyLog',
    retrieveUserDailyLogData = 'retrieveUserDailyLogData',
    retrieveVisibilityMap = 'retrieveVisibilityMap',
    retrieveWeldonActivityList = 'retrieveWeldonActivityList',
    retrieveWeldonActivityListSearchOptions = 'retrieveWeldonActivityListSearchOptions',
    retrieveWeldonActivityNewInstance = 'retrieveWeldonActivityNewInstance',
    retrieveWorkDayDateCalendar = 'retrieveWorkDayDateCalendar',
    retrieveWorkDayUserCalendar = 'retrieveWorkDayUserCalendar',
    retrieveWorkplaceEventSummary = 'retrieveWorkplaceEventSummary',
    retrieveWorkplacesSelectOption = 'retrieveWorkplacesSelectOption',
    retrieveWorkshiftById = 'retrieveWorkshiftById',
    retrieveWorkshiftSearchOptions = 'retrieveWorkshiftSearchOptions',
    retrieveWorkshiftUserEventList = 'retrieveWorkshiftUserEventList',
    retrieveZombieCalendar = 'retrieveZombieCalendar',
    sendNotificationForTask = 'sendNotificationForTask',
    searchBusCliente = 'searchBusCliente',
    searchBusMarca = 'searchBusMarca',
    searchBusOdc = 'searchBusOdc',
    searchBusTrabajador = 'searchBusTrabajador',
    searchCompanyUserDN = 'searchCompanyUserDN',
    searchCompanyUserList = 'searchCompanyUserList',
    searchCompanyUserMissionUserListDN = 'searchCompanyUserMissionUserListDN',
    searchDTypeDataCollection = 'searchDTypeDataCollection',
    searchMissionUserListByBrand = 'searchMissionUserListByBrand',
    searchNextDocTagList = 'searchNextDocTagList',
    searchPeriodicModel = 'searchPeriodicModel',
    searchPremisesHotelNet4Concepts = 'searchPremisesHotelNet4Concepts',
    searchPremisesHotelActivityNet4Concepts = 'searchPremisesHotelActivityNet4Concepts',
    searchServiceForms = 'searchServiceForms',
    searchTask = 'searchTask',
    searchWorkers = 'searchWorkers',
    searchWorkshift = 'searchWorkshift',
    sendDailyWork2ConnectCore = 'sendDailyWork2ConnectCore',
    sendNotification = 'sendNotification',
    sendPremisesCenterWork = 'sendPremisesCenterWork',
    sendPremisesCenterWork2ConnectCore = 'sendPremisesCenterWork2ConnectCore',
    sendPremisesGenericWork = 'sendPremisesGenericWork',
    sendPremisesGenericWork2ConnectCore = 'sendPremisesGenericWork2ConnectCore',
    sendPremisesHotelWork = 'sendPremisesHotelWork',
    sendPremisesHotelWork2ConnectCore = 'sendPremisesHotelWork2ConnectCore',
    sendQRMailByDNI = 'sendQRMailByDNI',
    sendQRToMissionUser = 'sendQRToMissionUser',
    sendTaskList = 'sendTaskList',
    sendWorkshiftList = 'sendWorkshiftList',
    signIn = 'signIn',
    synchronizeServiceWorkplaceUserAssignment = 'synchronizeServiceWorkplaceUserAssignment',
    syncMagicBagMinutes = 'syncMagicBagMinutes',
    toggleDTypeRepositoryLock = 'toggleDTypeRepositoryLock',
    toggleDTypeRepositoryHidden = 'toggleDTypeRepositoryHidden',
    updateMiniBus = 'updateMiniBus',
    updateNextOu = 'updateNextOu',
    uploadFile = 'uploadFile',
    uploadNextMasterXSSF = 'uploadNextMasterXSSF',
    uploadServiceTasksModelXSSF = 'uploadServiceTasksModelXSSF',
    validateDailyTaskCustom = 'validateDailyTaskCustom',
    validateDailyTaskCustomReduced = 'validateDailyTaskCustomReduced',
    validateDailyTaskCustomReducedList = 'validateDailyTaskCustomReducedList',
    validateDailyTaskPlanned = 'validateDailyTaskPlanned',
    validateDailyTaskWorked = 'validateDailyTaskWorked'
}
